import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import "react-phone-input-2/lib/style.css";

import { parseJwt, validateEmail } from "../utils/utils";

const { Select2, Date, DateTime, Text } = Inputs;

function OlvidePass({ history, match }) {
  const dispatch = useDispatch();
  const modelOlvide = useSelector((state) => state.olvidePass);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    const data = modelOlvide?.data?.data;
    const errorMessage = modelOlvide?.error?.response?.data?.mensaje;
    const error = modelOlvide?.error;

    if (error) {
      alert(errorMessage || "Ocurrió un error al realizar la operación");
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      if (data.status === 200) {
        alert(
          "Se ha enviado un mail con los pasos para reestablecer la contraseña"
        );
        history.push("/login");
        dispatch(controller.duck.actions.clear());
      } else {
        alert(data.mensaje);
        dispatch(controller.duck.actions.clear());
      }
    }
  }, [modelOlvide]);

  function submit() {
    if (!validateEmail(username)) {
      alert("Por favor proporcione un email con el formato correcto");
      return;
    }
    if (!username) {
      return alert("Por favor complete todos los campos");
    }
    let data = {
      email: username,
    };
    dispatch(controller.olvidePassThunk(data));
  }
  return (
    <Content
      title="Reestablecer contraseña"
      browserTitle="Reestablecer contraseña"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Recuperar contraseña">
            <Text
              labelPosition="above"
              size="sm"
              label="Correo electrónico"
              onChange={(evt) => setUsername(evt.target.value)}
            />
            <Button
              type="primary"
              text="Enviar"
              pullRight={true}
              onClick={() => submit()}
            />
            <Button
              type="default"
              text="Cancelar"
              onClick={() => {
                history.goBack();
              }}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default OlvidePass;
